{
  "name": "@uppy/drag-drop",
  "description": "Droppable zone UI for Uppy. Drag and drop files into it to upload.",
  "version": "6.0.0",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "drag-drop",
    "drag",
    "drop",
    "dropzone",
    "upload"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "preact": "^10.29.2"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "cssnano": "^8.0.1",
    "postcss": "^8.5.23",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^6.0.3"
  }
}
